export enum GoalStatus {
  ARCHIVED = "ARCHIVED",
  DISABLED = "DISABLED",
  DRAFT = "DRAFT",
  LIVE = "LIVE"
}
